module.exports = __webpack_public_path__ + "img/cloud-upload.3fbdb4a7.svg";